import styled from "styled-components";

const PLACEHOLDER_SVG = encodeURIComponent(
  `<svg fill="#000000" width="800px" height="800px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M16 15.503A5.041 5.041 0 1 0 16 5.42a5.041 5.041 0 0 0 0 10.083zm0 2.215c-6.703 0-11 3.699-11 5.5v3.363h22v-3.363c0-2.178-4.068-5.5-11-5.5z"/></svg>`
);
export const PLACEHOLDER = `data:image/svg+xml;utf8,${PLACEHOLDER_SVG}`;


export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const Th = styled.th`
  padding: 10px;
  background: #f4f4f4;
  border: 1px solid #ddd;
`;

export const Td = styled.td`
  padding: 10px;
  border: 1px solid #ddd;
`;

export const SearchInput = styled.input`
  padding: 10px;
  //margin-bottom: 20px;
  width: 100%;
  box-sizing: border-box;
  font-size: 12px;
`;


export const DownloadContainer = styled.section`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;